module.exports = __webpack_public_path__ + "img/portfolio-3.634b9cc5.png";